export default __webpack_public_path__ + "static/media/HowToCatch.f027a062.gif";